export const LIST = "list"
export const ENTITY = "entity"
export const SYSTEM = "system"

export const BIZ_APPLICATION = "biz/application"
